<template>
  <div>
    <div class="loading" v-if="isLoading">
      <div class="sk-three-bounce">
        <div class="sk-child sk-bounce1"></div>
        <div class="sk-child sk-bounce2"></div>
        <div class="sk-child sk-bounce3"></div>
      </div>
    </div>
    <b-row class="mb-3" v-if="$can('export')">
      <b-col sm>
          <div>
            <button
              type="button"
              class="btn btn-success"
              @click="exportTable"
              :disabled="isLoadingButton || !isParams"
            >
              <div
                class="d-inline-flex sk-three-bounce custom-loading-bounce"
                v-if="isLoadingButton"
              >
                <div class="sk-child sk-bounce1"></div>
                <div class="sk-child sk-bounce2"></div>
                <div class="sk-child sk-bounce3"></div>
              </div>
              <span v-else>
                Export
              </span>
            </button>
          </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <!-- Search Filter -->
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Search :"
            label-for="search"
            description="Searchable : Name, Email, Phone"
          >
            <b-input-group>
              <b-input-group-prepend>
                <b-dropdown :text="typeFilter" v-model="typeFilter" variant="secondary">
                  <b-dropdown-item v-for="(item, index) in typeData" :key="index" @click="typeFilter = item.value">
                    {{item.text}}
                  </b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>
              <b-form-input
                id="search"
                type="search"
                v-model="filterText"
                placeholder="Name, Email, Phone ..."
              />
              <b-input-group-append>
                <b-button
                  variant="secondary" 
                  type="button"
                  @click="resetFilter"
                >
                  Reset
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
      <!-- Daterange -->
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Date :"
            label-for="daterange"
            :state="dateRangeState === false ? false : computedDateRequiredState"
          >
            <template #invalid-feedback>
              <span v-if="dateRangeState === false">
                The date range must be at least 1 day
              </span>
              <span v-else-if="computedDateRequiredState === false">
                Date range is required when using organization/partner filter without specific search
              </span>
            </template>
            <b-input-group>
              <b-input-group-prepend is-text>
                <i class="fa fa-calendar"></i>
              </b-input-group-prepend>
              <range-picker
                id="daterange"
                :start="startDate"
                :end="endDate"
                :type="'clear'"
                :disable="false"
                :autoUpdate="false"
                :timePicker="false"
                @picker="doDateFilter"
              ></range-picker>
              <b-input-group-append>
                <b-button type="button" variant="secondary" @click="resetDateFilter">Reset</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <!-- Organization/Partner -->
      <b-col sm="6">
        <b-form-group
          id="organization"
          label-for="organization"
        >
          <label for="organization">
            Organisasi/Partner
          </label>
          <b-form-select
            id="organization"
            v-model="usage_type"
            aria-describedby="organizationFeedback"
            :plain="true"
            :options="[
              { value: '', text: 'Select a Partner/Organization' },
              { value: 0, text: 'All User' },
              { value: 1, text: 'Treasury User' },
              { value: 2, text: 'Partner' },
              { value: 3, text: 'Organization' }
            ]"
          >
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col v-if="this.usage_type" sm="6">
        <!-- Partner -->
        <b-form-group
          id="partner"
          label="Partner"
          label-for="partner"
          v-if="this.usage_type == 2"
        >
          <b-form-select
            id="partner"
            :plain="true"
            v-model="partner"
            :options="partnerOptions"
          >
          </b-form-select>
        </b-form-group>

        <!-- Organization -->
        <b-form-group
          id="organization"
          label="Organization"
          label-for="organization"
          v-if="this.usage_type == 3"
        >
          <b-form-select
            id="organization"
            :plain="true"
            v-model="organization"
            :options="organizationOptions"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col sm>
        <b-button
          class="mb-2"
          @click="doFilter"
          :disabled="stateButton"
          :style="buttonStyle"
        >
          Apply Filter
        </b-button>
        <p class="mb-3" :style="{ color: 'rgba(115, 129, 143, 1)' }">
          Click button 'Apply Filter' to apply the filter
        </p>
      </b-col>
    </b-row>

    <b-skeleton-table
      v-if="isLoadingTable == true"
      :rows="10"
      :columns="11"
      :table-props="{ bordered: true }"
    ></b-skeleton-table>

    <vuetable
      v-else
      ref="vuetable"
      :api-mode="false"
      :fields="fields"
      :per-page="limit"
      :data-manager="dataManager"
      pagination-path="pagination"
      :no-data-template="isParams ? defaultTemplate : noDataTemplate"
    >
      <template slot="name-slot" slot-scope="prop">
        <span>{{ prop.rowData.name }}</span>
      </template>
      <template slot="email-slot" slot-scope="prop">
        <span>{{ prop.rowData.email }}</span>
      </template>
      <template slot="referral_code-slot" slot-scope="prop">
        <span>{{ prop.rowData.referral_code == null ? '-' : prop.rowData.referral_code }}</span>
      </template>
      <template slot="organization-slot" slot-scope="prop">
        <span>{{ prop.rowData.organization}}</span>
      </template>
      <template slot="partner-slot" slot-scope="prop">
        <span>{{ prop.rowData.partner}}</span>
      </template>
      <template slot="actions-slot" slot-scope="prop">
        <div class="custom-actions d-flex align-items-start justify-content-start gap-2 flex-wrap">
          <button class="btn btn-success" @click="onAction('view-item', prop.rowData, prop.rowIndex)">Detail</button>
          <button class="btn btn-warning" v-if="$can('reset_pin')" @click="onAction('reset-pin-item', prop.rowData, prop.rowIndex)">Reset Pin</button>
          <button class="btn btn-info" v-if="$can('generate_monthly_statement')" @click="onAction('mutation', prop.rowData, prop.rowIndex)">Mutation</button>
          <button class="btn btn-danger" v-if="prop.rowData.is_blacklist === false && $can('user_block')" @click="onAction('block-item', prop.rowData, prop.rowIndex)">Block</button>
          <button class="btn btn-info" v-if="prop.rowData.is_blacklist === true && $can('user_block')" @click="onAction('unblock-item', prop.rowData, prop.rowIndex)">Unblock</button>
        </div>
      </template>
    </vuetable>
    <div
      v-show="isParams"
      class="vuetable-pagination ui basic segment grid"
    >
      <div class="wrapper-pagination-custom">
        <div class="pagination-custom-info">
          <p>{{ this.paginationInfo }}</p>
        </div>
        <div class="pagination-custom-button">
          <button :disabled="current_page === 1" @click="doMovePage('first')">
            <i
              v-if="current_page === 1"
              class="fa fa-angle-double-left disabled"
            ></i>
            <i v-else class="fa fa-angle-double-left"></i>
          </button>
          <button :disabled="current_page === 1" @click="doMovePage('prev')">
            <i v-if="current_page === 1" class="fa fa-angle-left disabled"></i>
            <i v-else class="fa fa-angle-left"></i>
          </button>
          <div>{{ this.current_page }}</div>
          <button :disabled="data.length < 10" @click="doMovePage('next')">
            <i v-if="data.length < 10" class="fa fa-angle-right disabled"></i>
            <i v-else class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Generate Mutation Modal -->
    <b-modal
      id="mutation-modal"
      size="md"
      centered
      hide-footer
      @hide="resetMutationModal"
      @shown="scrollToActiveYear"
    >
      <template #modal-title style=" background: #F0F3F5; ">
        Generate Mutation
        <small v-if="mutationUser" class="text-muted font-weight-normal ml-1">
          ({{ mutationUser.name }} - {{ mutationUser.email }})
        </small>
      </template>

      <div class="mutation-tabs">
        <button
          class="mutation-tab-btn"
          :class="{ active: mutationActiveTab === 'gold' }"
          @click="setMutationTab('gold')"
        >
          Asset - Gold
        </button>
        <button
          class="mutation-tab-btn"
          :class="{ active: mutationActiveTab === 'wallet' }"
          @click="setMutationTab('wallet')"
        >
          Wallet
        </button>
      </div>

      <div class="mutation-years-wrapper">
        <div class="mutation-years">
          <button
            v-for="year in mutationYears"
            :key="year"
            class="mutation-year-pill"
            :class="{ active: mutationSelectedYear === year }"
            @click="setMutationYear(year)"
          >
            {{ year }}
          </button>
        </div>
      </div>

      <div class="mutation-months-scroll">
        <div v-if="isLoadingMutation" class="text-center py-4">
          <div class="sk-three-bounce">
            <div class="sk-child sk-bounce1"></div>
            <div class="sk-child sk-bounce2"></div>
            <div class="sk-child sk-bounce3"></div>
          </div>
        </div>
        <template v-else>
          <div
            v-for="month in mutationMonths"
            :key="month.value"
            class="mutation-month-row"
          >
            <span>{{ month.label }}</span>
            <button
              class="mutation-download-btn"
              :disabled="isDownloadingMonth !== null"
              @click="downloadMutation(month)"
            >
              <i
                :class="isDownloadingMonth === `${mutationActiveTab}-${month.value}`
                  ? 'fa fa-spinner fa-spin'
                  : 'fa fa-download'"
              ></i>
            </button>
          </div>
          <div v-if="!mutationMonths.length" class="text-center py-3 text-muted">
            No data available
          </div>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import _ from "lodash";
  import moment from "moment";
  import Vue from "vue";
  import Vuetable from "vuetable-2/src/components/Vuetable";

  Vue.use(Vuetable);

  export default {
    components: {
      Vuetable
    },
    prop: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    data() {
      return {
        count: 0,
        page: 1,
        current_page: 1,
        limit: 10,
        data: [],
        startDate: '',
        endDate: '',
        filterText: '',
        dateRangeState: null,
        dateRequiredState: null,
        usage_type: '',
        partner: '',
        organization: '',
        typeFilter: 'Email',
        organizationFeedback: '',
        partnerOptions: [{ value: '', text: 'Select a Partner' }],
        organizationOptions: [{ value: '', text: 'Select an Organization' }],
        isLoading: false,
        isLoadingTable: false,
        isLoadingButton: false,
        paginationInfo: "",
        typeData : [
          {value:'Name', text:'Name' },
          {value:'Email', text:'Email' },
          {value:'Phone', text:'Phone' },
        ],
        dateDetail: {
          start_from: '',
          end_from: ''
        },
        errors: {
          code: '',
          message: '',
          status: ''
        },
        sort: 'users.created_at|desc',
        sortOrder: [
          {
            field: 'created_at',
            sortField: 'users.created_at',
            direction: 'desc'
          }
        ],
        moreParams: {},
        fields: [
          {
            name: 'name-slot',
            sortField: 'name',
            title: 'Name',
            width: '20%',
            length: '10'
          },
          {
            name: 'email-slot',
            sortField: 'email',
            title: 'Email'
          },
          {
            name: 'referral_code-slot',
            title: 'Referral Code'
          },
          {
            name: 'organization-slot',
            title: 'Organization'
          },
          {
            name: 'partner-slot',
            title: 'Partner'
          },
          {
            name: 'gender',
            sortField: 'gender',
            titleClass: 'center aligned',
            dataClass: 'center aligned',
            formatter: this.genderLabel
          },
          {
            name: 'birthday',
            sortField: 'birthday',
            title: 'Date of Birth',
            titleClass: 'center aligned',
            dataClass: 'center aligned',
            formatter: (value) => this.formatDate(value, 'DD-MM-YYYY')
          },
          {
            name: 'created_at',
            sortField: 'users.created_at',
            titleClass: 'center aligned',
            dataClass: 'center aligned',
            title: 'Register Date'
          },
          {
            name: 'actions-slot',
            title: 'Actions',
            titleClass: 'center aligned',
            dataClass: 'center aligned'
          }
        ],
        noDataTemplate:
          '<div class="text-center d-flex align-items-center justify-content-center" style="height: 120px;"><p>Use filter to show your data.</p></div>',
        defaultTemplate:
          '<div class="text-center d-flex align-items-center justify-content-center flex-column" style="height: 120px;"><p><strong>No results found.</strong></p><p>Please adjust your filter or search keywords</p></div>',
        mutationUser: null,
        mutationActiveTab: 'gold',
        mutationSelectedYear: new Date().getFullYear(),
        mutationYears: [],
        mutationMonths: [],
        isLoadingMutation: false,
        isDownloadingMonth: null,
      }
    },
    computed: {
      computedDateRequiredState() {
        // Check if date is required based on active filters
        const hasUsageTypeFilter = this.usage_type !== "";
        const hasPartnerFilter = this.partner !== "";
        const hasOrganizationFilter = this.organization !== "";
        const dateRangeEmpty = [this.startDate, this.endDate].every((f) => f === "");
        const hasFreetextFilter = this.filterText !== "";
        
        // Rule 3: If freetext is filled, date is not required (overrides rule 1)
        if (hasFreetextFilter) {
          return null;
        }
        
        // Rule 1: Date is required when usage_type, partner, or organization filter is active without freetext
        if ((hasUsageTypeFilter || hasPartnerFilter || hasOrganizationFilter) && dateRangeEmpty) {
          return false; // Invalid state
        }
        
        return null; // Valid state
      },
      stateButton() {
        const allFiltersEmpty = [
          this.partner, this.organization, this.filterText, this.usage_type, this.startDate, this.endDate
        ].every((f) => f === "");
        
        // Disable if all filters are empty
        if (allFiltersEmpty) return true;
        
        // Disable if there's a date range validation error
        if (this.dateRangeState === false) return true;
        
        // Check filter types
        const hasUsageTypeFilter = this.usage_type !== "";
        const hasPartnerFilter = this.partner !== "";
        const hasOrganizationFilter = this.organization !== "";
        const hasDateFilter = this.startDate !== "" || this.endDate !== "";
        const hasFreetextFilter = this.filterText !== "";
        
        // Rule 2 & 3: If freetext is filled, date is not required
        if (hasFreetextFilter) {
          return false;
        }
        
        // Rule 1: If has category filter without freetext, date is required
        if ((hasUsageTypeFilter || hasPartnerFilter || hasOrganizationFilter) && !hasDateFilter) {
          return true;
        }
        
        return false;
      },
      buttonStyle() {
        return {
          background: !this.stateButton ? "#7565F6" : "#c8ced3",
          color: !this.stateButton ? "#FFFFFF" : "inherit"
        };
      },
      isParams() {
        const params =
          // eslint-disable-next-line no-unused-vars
          Object.entries(this.moreParams).filter(([key, value]) => value)
            .length == 0;

        return !params && !this.isLoadingTable;
      },
    },
    watch: {
      // eslint-disable-next-line no-unused-vars
      data(newVal, oldVal) {
        if (
          this.$refs.vuetable &&
          typeof this.$refs.vuetable.refresh === "function"
        ) {
          this.$refs.vuetable.refresh();
        }
      },
      usage_type(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 0:
              this.organization = ''
              this.partner = ''
              break;
            case 1:
              this.organization = ''
              this.partner = 1
              break;
            case 2:
              this.organization = ''
              this.partner = ''
              this.$http
                .get(process.env.VUE_APP_SECRET + "admin/v1/partner-list")
                .then((response) => {
                  this.partnerOptions = [
                    ...this.partnerOptions,
                    ...response?.data?.map((item) => ({
                      value: item?.id,
                      text: item?.name || ''
                    }))
                  ];
                });
              break;
            case 3:
              this.organization = ''
              this.partner = ''
              this.$http
                .get(
                  process.env.VUE_APP_SECRET + "admin/v2/command/organization-command"
                )
                .then(response => {
                  this.organizationOptions = [
                    ...this.organizationOptions,
                    ...response?.data?.data
                  ];
                });
              break;
            default:
              this.organization = ''
              this.partner = ''
              break;
          }
        }
      }
    },
    created() {
      this.$events.$on("apply-filter", this.onFilterSet);
      this.$events.$on('movePage', this.onMovePage);
      this.$events.$on('date-set', this.onDateSet);
      this.$events.$on('date-filter-reset', this.onDateFilterReset);
    },
    beforeDestroy() {
      this.$events.$off("apply-filter", this.onFilterSet);
      this.$events.$off('movePage', this.onMovePage)
      this.$events.$off('date-set', this.onDateSet)
      this.$events.$off('date-filter-reset', this.onDateFilterReset)
    },
    methods: {
      formatDate (value, fmt = 'D MM YYYY') {
        return (value == null)
          ? '-'
          : this.moment(value, 'YYYY-MM-DD').format(fmt)
      },
      genderLabel (value) {
        if (value == null) {
          return '<span class="ui red label">Unknown</span>'
        } else if (value == 'Male') {
          return '<span class="ui teal label"><i class="large man icon"></i>Male</span>'
        } else {
          return '<span class="ui pink label"><i class="large woman icon"></i>Female</span>'
        }
      },
      onAction (action, data) {
        if (action == 'view-item') {
          const routeData = this.$router.resolve({name: 'Detail End User', params: { id: btoa(data.id)}});
          window.open(routeData.href, '_blank');
        } else if (action == 'block-item') {
          this.$swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this User!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, block!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
              if (result.value) {
                this.$http.post(`blacklist-user/` + data.id)
                .then(() => {
                  this.$swal.fire(
                    'Success!',
                    'This User has been block.',
                    'success'
                  ).then(() => {
                    location.reload();
                  }).catch((error) => {
                    if (error.response) {
                      this.errors.code = error.response.status;
                      this.errors.message = error.response.data.meta.message;
                      this.errors.status = error.response.data.meta.code;
                    }
                  })
                })
              } else if (result.dismiss === this.$swal.DismissReason.cancel) {
                this.$swal.fire(
                  'Cancelled',
                  'This User has been successfully canceled for block!',
                  'error'
                )
              }
          })
        } else if (action == 'unblock-item') {
          this.$swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this User!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, unblock!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
              if (result.value) {
                this.$http.post(`unblacklist-user/` + data.id)
                .then(() => {
                  this.$swal.fire(
                    'Success!',
                    'This User has been unblock.',
                    'success'
                  ).then(() => {
                    location.reload();
                  }).catch((error) => {
                    if (error.response) {
                      this.errors.code = error.response.status;
                      this.errors.message = error.response.data.meta.message;
                      this.errors.status = error.response.data.meta.code;
                    }
                  })
                })
              } else if (result.dismiss === this.$swal.DismissReason.cancel) {
                this.$swal.fire(
                  'Cancelled',
                  'This User has been successfully canceled for unblock!',
                  'error'
                )
              }
          })
        } else if (action == 'mutation') {
          this.openMutationModal(data);
        } else {
          this.$swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this User!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, reset it!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
              if (result.value) {
                this.$http.post(`reset-pin/` + data.id)
                .then(() => {
                  this.$swal.fire(
                    'Success!',
                    'This User has been reset pin.',
                    'success'
                  ).then(() => {
                    location.reload();
                  }).catch((error) => {
                    if (error.response) {
                      this.errors.code = error.response.status;
                      this.errors.message = error.response.data.meta.message;
                      this.errors.status = error.response.data.meta.code;
                    }
                  })
                })
              } else if (result.dismiss === this.$swal.DismissReason.cancel) {
                this.$swal.fire(
                  'Cancelled',
                  'This User has been successfully canceled for pin resetting!',
                  'error'
                )
              }
          })
        }
      },
      onFetch() {
        const newParams = Object.entries(this.moreParams)
          // eslint-disable-next-line no-unused-vars
          .filter(([key, value]) => key !== "usage_type" && value !== '' && value != null)
          .map(([key, value]) => `${key}=${value}`)
          .join("&");
        
        this.isLoadingTable = true;
        this.data = [];

        this.$http.get(`end-users?sort=${encodeURIComponent(this.sort)}&page=${this.page}&per_page=10${newParams ? `&${newParams}` : ""}`)
          .then((response) => {
            const datas = response.data.data;
            const datasCount = datas.length;
            const startIndex = (response.data.current_page - 1) * this.limit;
            const endIndex = Math.min(
              startIndex + this.limit,
              datasCount > 0 ? datasCount + startIndex : this.limit
            );

            this.data = datas;
            this.current_page = response.data.current_page;
            this.paginationInfo =
              datas.length > 0
                ? `Displaying ${startIndex + 1} to ${endIndex}`
                : "No relevant data";

            this.isLoadingTable = false;
          })
          .catch((err) => {
            this.isLoadingTable = false;
            this.handleLoadError(err);
          })
      },
      doMovePage(value) {
        this.$events.$emit('movePage', value)
      },
      onMovePage(eventData) {
        if (eventData === 'first') {
          this.page = 1;
          this.onFetch();
        } else if (eventData === 'prev') {
          this.page--;
          this.onFetch();
        } else {
          this.page++;
          this.onFetch();
        }
      },
      handleLoadError(error) {
        const code = error.response.data.meta.code;
        const message = error.response.data.meta.message;

        this.errors.code = code;
        this.errors.message = message;
        this.errors.status = code;
        this.isLoading = false;
        this.isLoadingTable = false;
        this.isLoadingButton = false;

        if (this.errors.code == 401) {
          this.$swal
            .fire(
              "Your session expired!",
              "Your session has expired. Please login again to access this page!",
              "error"
            )
            .then(() => {
              this.$router.push("/login");
            });
        } else if (this.errors.code == 403) {
          this.$router.push("/403");
        } else {
          this.$swal.fire("An error occured", message, "error").then(() => {
            this.$router.reload();
          });
        }
      },
      dataManager(sortOrder, pagination) {
        let local = this.data;

        if (sortOrder.length > 0) {
          const newSort = `${sortOrder[0].sortField}|${sortOrder[0].direction}`;
          if (this.sort !== newSort) {
            this.sort = newSort;
            this.onFetch();
          }
        }

        pagination = this.$refs.vuetable.makePagination(
          local.length,
          this.limit
        );

        let from = pagination.from - 1;
        let to = from + this.limit;

        return {
          pagination: pagination,
          data: local.length > 0 ? _.slice(local, from, to) : []
        };
      },
      exportTable() {
        this.isLoadingButton = true;

        const isDate = this.moreParams.start_from && this.moreParams.end_to;
        const dateParams = isDate
          ? `/${this.moreParams.start_from}/${this.moreParams.end_to}`
          : '';
        const newParams = Object.entries(this.moreParams)
          // eslint-disable-next-line no-unused-vars
          .filter(([key, value]) => !['usage_type', 'start_from', 'end_to'].includes(key) && value !== '' && value != null)
          .map(([key, value]) => `${key}=${value}`)
          .join("&");

        this.$http.get(`end-user${dateParams}?sort=${encodeURIComponent(this.sort)}${newParams ? `&${newParams}` : ""}`)
          .then((result) => {
            this.isLoadingButton = false
            const exportPath = result.data.meta.data;
            window.location.href = exportPath;
          }).catch((error) => {
            this.handleLoadError(error);
          })
      },
      doFilter() {
        this.$events.$emit("apply-filter");
      },
      onFilterSet() {
        this.page = 1;
        this.moreParams = {
          start_from: this.startDate,
          end_to: this.endDate,
          ...(this.filterText && { typeFilter: this.typeFilter }),
          filter: encodeURIComponent(this.filterText),
          usage_type: this.usage_type,
          partner: this.partner,
          organization: this.organization,
        };
        this.onFetch();
      },
      resetFilter () {
        this.filterText = ''
      },
      doDateFilter(value){
        this.$events.fire('date-set', value)
      },
      onDateSet(value)  {
        const startDate = moment(value.startDate);
        const endDate = moment(value.endDate);
        
        // Calculate the difference in days
        // const daysDiff = endDate.diff(startDate, 'days');
        
        // Must be at least 1 day difference
        // if (daysDiff < 1) {
        //   this.dateRangeState = false;
        //   return;
        // }
        
        // Valid range
        this.dateRangeState = null;
        this.startDate = startDate.format("YYYY-MM-DD");
        this.endDate = endDate.format("YYYY-MM-DD");
      },
      resetDateFilter () {
        this.startDate = ''
        this.endDate = ''
        this.dateRangeState = null
        // this.$events.$emit('date-filter-reset')
      },
      onDateFilterReset () {
        this.moreParams = Object.fromEntries(
          Object.entries(this.moreParams).filter(([key, value]) => {
            return [key, key !== "start_from" && key !== "end_to" ? value : ""];
          })
        );
      },
      openMutationModal(user) {
        this.mutationUser = user;
        this.mutationActiveTab = 'gold';
        const currentYear = new Date().getFullYear();
        this.mutationSelectedYear = currentYear;
        const startYear = 2018;
        this.mutationYears = Array.from(
          { length: currentYear - startYear + 1 },
          (_, i) => startYear + i
        );
        this.generateMutationMonths();
        this.$bvModal.show('mutation-modal');
      },
      setMutationTab(tab) {
        this.mutationActiveTab = tab;
        this.mutationSelectedYear = new Date().getFullYear();
        this.generateMutationMonths();
        this.$nextTick(() => this.scrollToActiveYear());
      },
      setMutationYear(year) {
        this.mutationSelectedYear = year;
        this.generateMutationMonths();
      },
      scrollToActiveYear() {
        const activeEl = document.querySelector('#mutation-modal .mutation-year-pill.active');
        if (activeEl) {
          activeEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      },
      generateMutationMonths() {
        const MONTH_NAMES = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
        const now = new Date();
        const currentYear = now.getFullYear();
        const maxMonth = this.mutationSelectedYear < currentYear ? 11 : now.getMonth();
        const months = [];
        for (let m = maxMonth; m >= 0; m--) {
          months.push({ label: MONTH_NAMES[m], value: m + 1 });
        }
        this.mutationMonths = months;
      },
      downloadMutation(month) {
        const key = `${this.mutationActiveTab}-${month.value}`;
        this.isDownloadingMonth = key;
        const type = this.mutationActiveTab;
        const userId = this.mutationUser.id;
        const yearMonth = `${this.mutationSelectedYear}-${String(month.value).padStart(2, '0')}`;
        this.$http
          .get(`monthly-statement/${type}/${userId}/${yearMonth}`, { responseType: 'blob' })
          .then((result) => {
            this.isDownloadingMonth = null;
            const disposition = result.headers['content-disposition'];
            let filename = `mutation-${type}-${yearMonth}.pdf`;
            if (disposition) {
              const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
              if (match && match[1]) filename = match[1].replace(/['"]/g, '').trim();
            }
            const blob = new Blob([result.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            this.isDownloadingMonth = null;
            this.handleLoadError(error);
          });
      },
      resetMutationModal() {
        this.mutationUser = null;
        this.mutationActiveTab = 'gold';
        this.mutationMonths = [];
        this.isDownloadingMonth = null;
      },
    },
  }
</script>
<style>
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}

/* Pagination Custom */
.wrapper-pagination-custom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9fafb;
}

.pagination-custom-button {
  display: flex;
}

.pagination-custom-button button {
  width: 28px;
  height: 47px;
  padding: 13px 16px;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  border: solid rgba(0,0,0,0.3);
}

.pagination-custom-button button:first-child {
  padding: 13px 16px 13px 30px;
  border-radius: 4px 0 0 4px;
  border-width: 1px 0 1px 1px
}

.pagination-custom-button button:nth-child(2),
.pagination-custom-button button:last-child {
  font-size: 1.3em;
  border-width: 1px;
}

.pagination-custom-button button:last-child {
  border-radius: 0 4px 4px 0;
}

.pagination-custom-button button i.disabled {
  opacity: 0.6;
}

.pagination-custom-button div {
  width: 28px;
  height: 47px;
  font-size: 1em;
  font-weight: 500;
  background: #FFFFFF;
  border: solid rgba(0,0,0,0.3);
  border-width: 1px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-loading-bounce {
  width: 72px !important;
  height: 18px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.custom-loading-bounce .sk-child {
  width: 6px !important;
  height: 6px !important;
  background: #ffffff !important;
}

/* Actions Column */
.custom-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.custom-actions .btn-info,
.custom-actions .btn-danger {
  color: #ffffff !important;
}

/* Mutation Modal */
.mutation-tabs {
  display: flex;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 16px;
}
.mutation-tab-btn {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 16px;
  font-size: 14px;
  color: #73818f;
  cursor: pointer;
  margin-bottom: -1px;
  outline: none;
}
.mutation-tab-btn.active {
  color: #212529;
  font-weight: 600;
  border-bottom-color: #212529;
}
.mutation-years-wrapper {
  overflow-x: auto;
  margin-bottom: 8px;
  scrollbar-width: none;
}
.mutation-years-wrapper::-webkit-scrollbar {
  display: none;
}
.mutation-years {
  display: flex;
  gap: 8px;
  padding: 4px 0 12px;
  width: max-content;
}
.mutation-year-pill {
  background: none;
  border: 1px solid #c8ced3;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 13px;
  color: #444;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
  outline: none;
}
.mutation-year-pill.active {
  background: #E2EEFD;
  border-color: #1877F2;
  color: #1877F2;
}
.mutation-month-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  border: 1px solid #e4e7eb;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
  color: #212529;
  margin-bottom: 8px;
}
.mutation-month-row:last-child {
  margin-bottom: 0;
}
.mutation-download-btn {
  background: none;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  color: #555;
  cursor: pointer;
  transition: all 0.15s;
  outline: none;
  line-height: 1;
}
.mutation-download-btn:hover:not(:disabled) {
  color: #7565F6;
}
.mutation-download-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
#mutation-modal .modal-title {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: baseline;
  gap: 4px;
  flex-wrap: wrap;
}
#mutation-modal .modal-title small {
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
}
#mutation-modal .modal-header {
  background: #F0F3F5;
  border-radius: 4px 4px 0 0;
}
#mutation-modal .modal-header .close:hover {
  opacity: 1;
}
.mutation-months-scroll {
  max-height: 360px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 2px;
}
</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
